module.exports = __webpack_public_path__ + "static/media/AOI.c13fa089.zip";